// This file was generated by svgr, do not edit it.
import * as React from 'react'
import clsx from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const OrderIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'order'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M2 2H3.99601L6.6507 14.4511C6.74808 14.9071 7.00067 15.3148 7.36498 15.6039C7.72929 15.893 8.18254 16.0455 8.64671 16.0351H18.4072C18.8615 16.0343 19.3019 15.878 19.6557 15.5918C20.0096 15.3056 20.2556 14.9068 20.3533 14.4612L22 7.01253H5.06387M8.93613 20.9975C8.93613 21.5512 8.48931 22 7.93812 22C7.38694 22 6.94012 21.5512 6.94012 20.9975C6.94012 20.4438 7.38694 19.995 7.93812 19.995C8.48931 19.995 8.93613 20.4438 8.93613 20.9975ZM19.9142 20.9975C19.9142 21.5512 19.4674 22 18.9162 22C18.365 22 17.9182 21.5512 17.9182 20.9975C17.9182 20.4438 18.365 19.995 18.9162 19.995C19.4674 19.995 19.9142 20.4438 19.9142 20.9975Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
OrderIcon.displayName = 'OrderIcon'
export { OrderIcon }
